const ADMIN_PERMISSION = "*:*";

export const VIEW_PERMISSION_MAP = {
    CONVERSATION_HISTORY: ["conversation:*"],
    SCENE: ["scene:*"],
    SCENE_TEMPLATE: ["scene-template:*"],
    INTEGRATION: ["integration:*"],
    BULK_TEST: ["bulk-test:*"],
    DEPLOYMENT: ["deploy:*"],
    MEMBER: ["member:*"],
    SETTING: ["setting:*"],
} as const;

const getPermissionView = (permission: string) => {
    return permission.split(':')[0];
};

export const hasAdminPermission = (userPermissions: string[]) => {
    return userPermissions.includes(ADMIN_PERMISSION);
};

const hasPermission = (userPermissions: string[], requiredPermission: string) => {
    return (
        userPermissions.includes(requiredPermission)
            || userPermissions.includes(`*:${getPermissionView(requiredPermission)}`)
    );
};

export const checkPermission = (userPermissions: string[], requiredPermissions: readonly string[]) => {
    return (
        hasAdminPermission(userPermissions)
            || userPermissions.some(permission => getPermissionView(permission) === "*")
            || requiredPermissions.some(requiredPermission => hasPermission(userPermissions, requiredPermission))
    );
};
